import {useEffect,useRef, useLayoutEffect, useState} from "react";
import {permissionObj} from "../../../Helpers/permission";
import {MODELS} from "../../../Apis/Models";
import {TABLES} from "../../../Apis/Tables";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {PROVIDER_SUB_VIEW_MODEL, TABS_PROVIDER} from "../Model/Model";
import routes from "../../../Routes/routes";
import {clearSearchFilters} from "../../../reduxToolkit/Search/SearchSlice";
import {VIEW_TYPE} from "../../../enums/ViewType";
import {USER_TYPE_MODEL} from "../../../enums/userTypeEnum";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

/**
 * @params {importFileShow boolean}
 * @params {supplierId: string}
 * @params {filterDialogShow: boolean}
 * @params {setSimpleSearch: {(value: (((prevState: boolean) => boolean) | boolean)): void ,(value: (((prevState: undefined) => undefined) | undefined)): void}
 * @params {deleteSupplierShow: boolean}
 * @params {contractorId: string}
 * @params { criteria: unknown}
 * @params {setBodyForExport: {(value: (((prevState: string) => string) | string)): void, (value: (((prevState: undefined) => undefined) | undefined)): void}}
 * @params {deleteOrderShow: boolean}
 * @params {setFinalArray: {(value: (((prevState: []) => []) | [])): void, (value: (((prevState: undefined) => undefined) | undefined)): void}}
 * @params {setActiveStep: {(value: (((prevState: number) => number) | number)): void, (value: (((prevState: undefined) => undefined) | undefined)): void}}
 * @params {setCriteria: {(value: unknown): void, (value: (((prevState: undefined) => undefined) | undefined)): void}}
 * @params {handleStepChange: handleStepChange}
 * @params {setCristeriaListBody: {(value: unknown): void, (value: (((prevState: undefined) => undefined) | undefined)): void}}
 * @params {setDeleteSupplierShow: {(value: (((prevState: boolean) => boolean) | boolean)): void, (value: (((prevState: undefined) => undefined) | undefined)): void}}
 * @params {setSelectSupplierForDelete: {(value: (((prevState: []) => []) | [])): void, (value: (((prevState: undefined) => undefined) | undefined)): void}}
 * @params {search: boolean, modified: boolean}
 * @params {selectOrderForDelete: []}
 * @params {moduleId: string}
 * @params {navigate}
 * @params {setCleanAdvance: {(value: (((prevState: boolean) => boolean) | boolean)): void, (value: (((prevState: undefined) => undefined) | undefined)): void}}
 * @params {setSearchElement: {(value: (((prevState: string) => string) | string)): void, (value: (((prevState: undefined) => undefined) | undefined)): void}}
 * @params {cleanAdvance: boolean, finalArray: []}
 * @params {activeStep: number}
 * @params {setLoaded: {(value: (((prevState: boolean) => boolean) | boolean)): void, (value: (((prevState: undefined) => undefined) | undefined)): void}}
 * @params {cristeriaListBody: unknown}
 * @params {selectSupplierForDelete: []}
 * @params {setModified: {(value: (((prevState: boolean) => boolean) | boolean)): void, (value: (((prevState: undefined) => undefined) | undefined)): void}}
 * @params {permission}
 * @params {setSearch: {(value: (((prevState: boolean) => boolean) | boolean)): void, (value: (((prevState: undefined) => undefined) | undefined)): void}}
 * @params {setFilterDialogShow: {(value: (((prevState: boolean) => boolean) | boolean)): void, (value: (((prevState: undefined) => undefined) | undefined)): void}}
 * @params {steps: []}
 * @params {searchElement: string}
 * @params {bodyForExport: string}
 * @params {setSelectOrderForDelete: {(value: (((prevState: []) => []) | [])): void, (value: (((prevState: undefined) => undefined) | undefined)): void}}
 * @params {DEV}
 * @params {t}
 * @params {setDeleteOrderShow: {(value: (((prevState: boolean) => boolean) | boolean)): void, (value: (((prevState: undefined) => undefined) | undefined)): void}}
 * @params {option: string}
 * @params {importFileShow}
 * @constructor
 */

export const ProvidersPanelApp = () => {
    const location = useLocation();
    let {state} = location;
    const navigate = useNavigate();
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const [steps, setSteps] = useState([]);
    const currentTab = state?.currentTab;
    const currentSubView = state?.currentSubView;
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const [filterDialogShow, setFilterDialogShow] = useState(false);
    const [finalArray, setFinalArray] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('providerId'));
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [importFileShow, setImportFileShow] = useState(false);
    const [searchElement, setSearchElement] = useState('');
    const [search, setSearch] = useState(false);
    const {permission} = useSelector((state) => state.authenticatioauthennSlice);
    const [moduleId, setModuleId] = useState(MODELS.Order);
    const [option, setOption] = useState(TABLES.ORDERS);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [bodyForExport, setBodyForExport] = useState('');
    const [criteria, setCriteria] = useState();
    const [subView, setSubView] = useState(null);
    const [selectedList, setSelectedList] = useState([]);
    const [canceledList, setCanceledList] = useState([]);
    const [deleteSupplierShow, setDeleteSupplierShow] = useState(false);
    const [deleteApprovalFlowShow, setDeleteApprovalFlowShow] = useState(false);
    const [deleteOrderShow, setDeleteOrderShow] = useState(false);
    const [modified, setModified] = useState(false); // Flag to track modifications
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [view, setView] = useState(VIEW_TYPE.LIST.name);
    const [searchId, setSearchId] = useState("tbl_ppa_search_id");
    const viewType = VIEW_TYPE.LIST.viewType
    const userTypeId = USER_TYPE_MODEL.SUPPLIER_IN_CHARGE
    const [activeStep, setActiveStep] = useState(supplierId ? 0 : null);
    const btnUpdateRef = useRef();

    // Sets up the initial steps and determines which tabs should be shown based on user permissions
    useLayoutEffect(() => {
        let activeTab = null;
        const stepConfig = [
            {
                tab: TABS_PROVIDER.PURCHASE_ORDERS.TRANS,
                perm: [permissionObj?.WEB_SUPPLIER_ORDER_READ],
                index: TABS_PROVIDER.PURCHASE_ORDERS.INDEX
            },
            {
                tab: TABS_PROVIDER.SUPPLIERS.TRANS,
                perm: [permissionObj?.WEB_SUPPLIER_READ],
                index: TABS_PROVIDER.SUPPLIERS.INDEX
            },
            {
                tab: TABS_PROVIDER.MANAGE.TRANS,
                perm: [permissionObj?.WEB_SUPPLIER_MANAGE_READ],
                index: TABS_PROVIDER.MANAGE.INDEX
            },
            {
                tab: TABS_PROVIDER.DOCUMENTATION.TRANS,
                perm: [permissionObj?.WEB_SUPPLIER_APPROVAL_FLOW_READ, permissionObj?.WEB_SUPPLIER_REQUEST_READ],
                index: TABS_PROVIDER.DOCUMENTATION.INDEX
            },
        ];

        const auxStep = stepConfig.reduce((acc, {tab, perm, index}) => {
            const hasPermission = DEV || perm.some(p => permission?.includes(p));
            if (hasPermission) {
                acc.push({label: t(tab), index: index});
                if (activeTab === null) activeTab = index;
            }
            return acc;
        }, []);

        setSteps(auxStep);

        if (activeTab !== null && !currentTab) handleStepChange(activeTab);
    }, [permission, t]);

    // Updates view when the location changes
    useLayoutEffect(() => {
        if (currentTab !== undefined) {
            handleStepChange(currentTab);
            setSearchElement('');
        }
    }, [currentTab]);

    // useEffect to reset checkboxes and clear selection when activeStep or view changes
    useEffect(() => {
        reset();
        dispatch(clearSearchFilters()); // Clear search filters
    }, [view]); // Depend on activeStep and view


    const handleModuleOption = (step) => {
        switch (step) {
            case TABS_PROVIDER.PURCHASE_ORDERS.INDEX:
                setModuleId(MODELS.Order);
                setOption(TABLES.ORDERS);
                break;
            case TABS_PROVIDER.SUPPLIERS.INDEX:
                setModuleId(MODELS.Supplier);
                setOption(TABLES.SUPPLIERS);
                break;
            case TABS_PROVIDER.DOCUMENTATION.INDEX:
                setModuleId(MODELS.APPROVAL_FLOW)
                setOption(
                    resolveDocumentationSubView() === PROVIDER_SUB_VIEW_MODEL.DOCUMENTATION.REQUESTS
                        ? TABLES.REQUEST_SUPPLIER
                        : TABLES.APPROVAL
                )
                break;
        }
    }

    /**
     * Resolves the documentation subview the user is allowed to see.
     * The subview coming from the navigation state is honored only when the user can read it,
     * otherwise the first readable subview is used (null when none is readable).
     */
    const resolveDocumentationSubView = () => {
        const approval = DEV || permission?.includes(permissionObj.WEB_SUPPLIER_APPROVAL_FLOW_READ);
        const request = DEV || permission?.includes(permissionObj.WEB_SUPPLIER_REQUEST_READ);
        const allowed = [];

        if (approval) allowed.push(PROVIDER_SUB_VIEW_MODEL.DOCUMENTATION.APPROVAL_FLOW);
        if (request) allowed.push(PROVIDER_SUB_VIEW_MODEL.DOCUMENTATION.REQUESTS);

        if (allowed.includes(currentSubView)) return currentSubView;

        return allowed[0] || null;
    };

    //Handles tab changes, updates module and table based on the selected step.
    const handleStepChange = (step) => {
        reset();
        setActiveStep(step);
        navigate(location.pathname, {replace: true, state: {}});
        handleModuleOption(step)
        subViewChange(step)

    };
    // Updates the current subview depending on the selected tab
    const subViewChange = (step) => {
        switch (step) {
            case TABS_PROVIDER.DOCUMENTATION.INDEX:
                // Requests is the landing subview only when the approval flow is not available
                setSubView(resolveDocumentationSubView());
                break;
            default:
                if (currentSubView !== undefined && currentSubView !== null) {
                    setSubView(currentSubView);
                }
                break;
        }
    };

    const handleSubViewChange = (view) => {
        reset();
        if(view === PROVIDER_SUB_VIEW_MODEL.DOCUMENTATION.APPROVAL_FLOW){
            setOption(TABLES.APPROVAL)
        }
        if(view === PROVIDER_SUB_VIEW_MODEL.DOCUMENTATION.REQUESTS){
            setOption(TABLES.REQUEST_SUPPLIER)
        }
        setSubView(view);
    };

    //Checks whether the current user has the required permission to display action buttons
    const permissionButtons = (list) => {
        const permissionRequired = list[activeStep];

        if (!permissionRequired) {
            return false;
        }
        if (permissionRequired === true) {
            return true;
        }
        return DEV || permission?.includes(permissionRequired);
    };

    const handleDelete = (step) => {
        switch (step) {
            case TABS_PROVIDER.PURCHASE_ORDERS.INDEX:
                setDeleteOrderShow(true)
                break
            case TABS_PROVIDER.SUPPLIERS.INDEX:
                setDeleteSupplierShow(true)
                break
            case TABS_PROVIDER.DOCUMENTATION.INDEX:
                setDeleteApprovalFlowShow(true)
        }
    }

    const handleCreate = () => {
        switch (activeStep) {
            case TABS_PROVIDER.PURCHASE_ORDERS.INDEX:
                navigate(routes.employee.createOrder,
                    { state: {
                            backUrl: routes.suppliers.main,
                            currentTab: TABS_PROVIDER.PURCHASE_ORDERS.INDEX,
                        }
                    }
                );
                break;
            case TABS_PROVIDER.SUPPLIERS.INDEX:
                navigate(routes.suppliers.addSuppliers,
                    { state: {
                            backUrl: routes.suppliers.main,
                            currentTab: TABS_PROVIDER.SUPPLIERS.INDEX,
                        }
                    }
                );
                break;
            case TABS_PROVIDER.DOCUMENTATION.INDEX:
                navigate(routes.suppliers.createApprovalLevel)
                break;
        }
    };

    const reset = () => {
        setSearchElement("");
        setFinalArray([]);
        setSelectedList([]);
        setIsAllChecked(false); // Reset "select all" checkbox for contracts
    }

    return {
        view,
        setView,
        steps,
        setActiveStep,
        handleStepChange,
        activeStep,
        supplierId,
        DEV,
        setImportFileShow,
        filterDialogShow,
        setFinalArray,
        importFileShow,
        setLoaded,
        setSearchElement,
        setSearch,
        setSimpleSearch,
        navigate,
        contractorId,
        permission,
        search,
        searchElement,
        finalArray,
        setFilterDialogShow,
        t,
        bodyForExport,
        setBodyForExport,
        criteria,
        setCriteria,
        selectedList,
        setSelectedList,
        setDeleteSupplierShow,
        deleteSupplierShow,
        setDeleteApprovalFlowShow,
        deleteApprovalFlowShow,
        moduleId,
        option,
        deleteOrderShow,
        setDeleteOrderShow,
        setModified,
        modified,
        subView,
        setSubView,
        permissionButtons,
        handleSubViewChange,
        handleCreate,
        handleDelete,
        searchId,
        viewType,
        userTypeId,
        btnUpdateRef,
        isAllChecked,
        setIsAllChecked,
        canceledList,
        setCanceledList
    }
}
